import React from "react";
import { Auth } from "aws-amplify";
// ANT DESIGN COMPONENTS
import { Modal, Button, Spin } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateUserLogged } from "../../redux/home/homeSlice";
import {
  usePostTermnsAndConditionsMutation,
  useLazyGetCurrentLoggedUserQuery,
} from "../../redux/users/userAPI";
import { normalizeUserResponse } from "../../redux/users/normalizeUser";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// COMPONENTS
import EulaText from "../termsAndConditions/EulaText";

function TermsAndConditions() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { userLogged } = useSelector((state: any) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [postTermsAndConditions, { isLoading }] = usePostTermnsAndConditionsMutation();
  const [triggerGetMe] = useLazyGetCurrentLoggedUserQuery();
  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickAccept = async () => {
    const token = await GETJwtToken();
    await postTermsAndConditions({ token, body: {} }).unwrap();
    // Refetch the user — the POST response has stale data (pre-update).
    const meResponse = await triggerGetMe({ token }).unwrap();
    const raw = meResponse?.data?.user ?? meResponse?.data;
    if (raw) {
      // Normalize FIRST, then merge over the prior userLogged. Spreading raw
      // directly without normalization re-introduces FlatBuffer UuidT objects
      // that crash DrawerUserInformation render.
      const normalized = normalizeUserResponse(raw);
      const acceptedTerms = normalized.acceptedTerms || new Date().toISOString();
      dispatch(
        updateUserLogged({
          ...userLogged,
          ...normalized,
          acceptedTerms,
        }),
      );
    }
  };

  const signOut = async () => {
    await Auth.signOut();
    window.location.href = `${process.env.REACT_APP_LOGIN_ROUTE}`;
  };
  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Modal
      onOk={onClickAccept}
      closable={false}
      open={!userLogged.acceptedTerms}
      width="50%"
      footer={
        <div className="generalStyles__flexEnd mt-1">
          <div>
            <Button type="default" className="buttonStyle__2" onClick={signOut}>
              {t("header.signOut")}
            </Button>
          </div>
          <div className="generalStyles__mlFix">
            <Button type="default" className="buttonStyle__1" onClick={onClickAccept}>
              {t("general.accept")}
            </Button>
          </div>
        </div>
      }
    >
      <Spin spinning={isLoading}>
        {/** ************************* */}
        {/** BODY */}
        <div style={{ height: "55vh", overflowY: "scroll", padding: "15px" }}>
          <EulaText />
        </div>
      </Spin>
    </Modal>
  );
}

export default TermsAndConditions;
